import { render, staticRenderFns } from "./m_certificateForm.vue?vue&type=template&id=573fb6c3&scoped=true&"
import script from "./m_certificateForm.vue?vue&type=script&lang=js&"
export * from "./m_certificateForm.vue?vue&type=script&lang=js&"
import style0 from "./m_certificateForm.vue?vue&type=style&index=0&id=573fb6c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573fb6c3",
  null
  
)

export default component.exports